import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoadupRequestConfirmationDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section
                id="loadup-request-confirmation"
                className="loadup-request order-support order-support--content-centered"
            >
                <div className="main-container">
                    <div className="detail-container">
                        <h1>{t`Mattress Pickup Request`}</h1>
                        <div className="loadup-request__body">
                            <p>{t`Thank you for submitting a Mattress Pickup Request Form!`}</p>
                            <p>{t`Please allow 1-3 business days for our pickup partners to email you for scheduling.`}</p>
                        </div>
                    </div>
                </div>
            </section>
        </PageSkeleton>
    );
};
